import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import $ from "jquery";
import { Paginator } from "primereact/paginator";
import { DownloadAttachment } from "../../Actions/AttachmentAPI";
import { OverlayTrigger, Popover } from "react-bootstrap";
class MakeCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      isView: false,
    };
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize = () => {
    if (window.innerWidth > 987) {
      this.setState({
        isView: true,
      });
    } else {
      this.setState({
        isView: false,
      });
    }
  };
  render() {
    const { arraylist, currentPage, pageSize, totalRecords, MakeSearchList, t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist.length != 0 ? (
          <Paginator
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !--{t("CommonText.NoItem")}--!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick, deleteMake, MakeSearchList, t } = this.props;
    return arraylist && arraylist.length ?
      <>
        <div className="col-12 pt-4 px-4 py-3" style={{ backgroundColor: "#FFFFFF" }}>
          <div
            className={`${window.innerWidth < 1000 ? "" : this.state.isView === false ? "table-container2" : "table-container1"
              } table-responsive`} >
            <table id="tableview" className="table cellborder">
              <thead>
                <tr className="table-active section-color border">
                  <th
                    className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"} text-center align-middle border-right border-left border-top  plan-color`}
                    style={{ minWidth: "250px", maxWidth: "250px", width: "250px", }}>
                    <span className="spandoc-thead">{t("ShipEquipmentStatusScreen.Make")} </span>
                  </th>
                  <th className={`${window.innerWidth < 1000 ? "" : "vendor-tr-title"} text-center align-middle border-right border-left border-top  plan-color`}
                    style={{ minWidth: "250px", maxWidth: "250px", width: "250px", }}>
                    <span className="spandoc-thead">{t("ShipEquipmentStatusScreen.Model")}</span>
                  </th>
                  <th className={`${window.innerWidth < 1000 ? "border-right" : "vendor-tr-title"
                    } border-top border-right text-center align-middle border-left  align-middle  plan-color`}
                    style={{ minWidth: "250px", maxWidth: "250px", width: "250px", }}>
                    {" "}
                    <span className="spandoc-thead">{t("FlagScreen.Attachment")}</span>
                  </th>
                  <th className={`${window.innerWidth < 1000 ? "border-right" : "action"} border-top border-right text-center align-middle border-left  plan-color`}
                    style={{ minWidth: "100px", maxWidth: "100px", width: "100px", }}>
                    <span className="spandoc-thead">{t("VendorManagementScreenContent.Action")}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {arraylist ? (
                  arraylist &&
                  arraylist.map((item, index) => {
                    return (
                      <>
                        <tr className="border-top border-bottom border-left border-right">
                          <td
                            className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"
                              } text-center align-middle spanTopBar border-right border-left border-bottom`}>
                            <span className="spanTopBar" style={{ color: "#000000" }}>
                              {item.makeName}
                            </span>
                          </td>
                          <td
                            className={`${window.innerWidth < 1000 ? "" : "vendor-tr-title"
                              } align-middle spanTopBar border-right border-bottom border-left px-0`}>
                            {item?.modelList.map((i, ind) => (
                              <tr className={`${item?.modelList.length - 1 !== ind ? "border-bottom vendor-td" : ""}`}
                                id={"modelName" + ind + 1 + "value"}
                                style={{ height: $("#modelName" + ind + 1 + "value").outerHeight() <= $("#attName" + ind + 1 + "test").outerHeight() ? $("#attName" + ind + 1 + "test").outerHeight() : $("#modelName" + ind + 1 + "value").outerHeight() }}>
                                <td className="break-text remove-border text-center">
                                  <span className="spanTopBar pl-3">{i.modelName ? i.modelName : "-"}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </td>

                          <td className={`${window.innerWidth < 1000 ? "" : "vendor-tr-title"} align-middle spanTopBar border-right border-bottom border-left px-0`}>
                            {item?.modelList.map((i, ind) => (
                              <tr className={`${item?.modelList.length - 1 !== ind ? "border-bottom vendor-td" : ""}`}
                                id={"attName" + ind + 1 + "test"}
                                style={{ height: $("#modelName" + ind + 1 + "value").outerHeight() <= $("#attName" + ind + 1 + "test").outerHeight() ? $("#attName" + ind + 1 + "test").outerHeight() : $("#modelName" + ind + 1 + "value").outerHeight() }}>
                                <td className="px-4 break-text remove-border text-center">
                                  <span className="spanTopBar">
                                    {i.attachmentName ? i.attachmentName : "-"}
                                    {i.attachmentName ? (
                                      <i className="fa fa-download click ml-1" onClick={() => this.DownloadDoc(
                                        i.attachmentName, i.attachmentGuid)} aria-hidden="true"
                                        style={{ color: " #1a3464", fontSize: "1.2rem", }}></i>) : ("")}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </td>

                          <td
                            className={`${window.innerWidth < 1000 ? "border-right" : "action"
                              } border-right text-center tableview-set align-middle`}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderedit()}
                            >
                              <i
                                className="fa fa-edit fa-lg click m-1 px-1"
                                onClick={() => eyeclick(item)}
                                aria-hidden="true"
                                style={{ color: " #1a3464", fontSize: "1.8rem" }}
                              ></i>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderdelete()}
                            >
                              <i
                                className="fa fa-trash click m-1 px-2"
                                onClick={() => deleteMake(item)}
                                aria-hidden="true"
                                style={{ color: " #1a3464", fontSize: "1.8rem" }}
                              ></i>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      </>
                    );
                  })
                ) : (
                  <>
                    <tr>
                      <span className="text-center">{t("CommonText.NoItem")}</span>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </>

      : null;
  };
  DownloadDoc(attachmentName, attachmentGuid) {
    this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
  }

  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    MakeSearchList: state.lookupReducer.MakeSearchList || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MakeCard)));
